import React, { } from 'react';
import { makeStyles, Grid, Typography, } from '@material-ui/core';
//import { useHistory } from 'react-router-dom'
//import randomMC from 'random-material-color'
//import { AuthContext } from '../context'
import { Paper } from '../components'


export default function AboutScreen(props) {

  const classes = useStyles({ ...props })()


  return (
    <Grid container className={classes.container}>
      {/* <PopUp 
        modalName={modalName} 
        open={modal}
        setModal={() => setModal(!modal)}
     />*/}
      <Grid container className={classes.containerHeader} justify="center" alignItems="flex-start" style={{ padding: "5px 5px 9px 5px" }}>
        <Grid item xs={7} md={3}>
          <img src="../../assets/about.svg" alt="" />
        </Grid>
        <Grid item md={9}>
          <Grid container>
            <Grid item md={12} lg={11}>
              <Typography>Sobre Unio</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Paper>
        <Grid container className={classes.containerPaper}>
          <Grid item xs={12}>
            <Typography>¿Quiénes somos?</Typography>
            <Typography>
              Somos una empresa de innovación y especializados en desarrollo de tecnologías
              e información especialmente diseñada para mejorar y hacer mas eficiente la
              gestión en salud. Reunimos diferentes actores del mundo médico y tecnológico
              con el objetivo de mejorar el acceso a medicamentos para profesionales de la
              salud y sus pacientes, optimizando y elevando los estándares de calidad.
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}


const useStyles = ({ buttonActive, ...props }) => makeStyles((theme) => ({
  container: {
    display: "block",
    height: "100%",
    [theme.breakpoints.up("md")]: {
      padding: "50px 50px 0 50px",
    }
  },
  containerHeader: {
    '& > div:nth-child(1)': {
      '& img': {
        [theme.breakpoints.up("md")]: {
          width: "100%",
        }
      }
    },
    '& > div:nth-child(2)': {
      padding: " 0 0 0 40px",
      [theme.breakpoints.down("sm")]: {
        display: "none"
      },
      '& > div': {
        '& > div:nth-child(1), > div:nth-child(2)': {
          '& > p': {
            color: theme.palette.primary.main,
            fontSize: "1.125rem",
            lineHeight: "1.375rem",
            fontWeight: "bold",
          }
        }
      }

    },
  },
  containerPaper: {
    height: "60vh",
    overflowY: "scroll",
    display: "block",
    "&::-webkit-scrollbar": {
      width: "1px",
      height: "8px",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,.1)",
      borderRadius: "10px",
    },
    '& div': {
      '& p:nth-child(1)': {
        color: theme.palette.primary.main,
        fontSize: "1.125rem",
        lineHeight: "1.375rem",
        fontWeight: "bold",
        textAlign: "center",
        [theme.breakpoints.up("md")]: {
          textAlign: "justify"
        }
      },
      '& p': {
        color: theme.palette.primary.main,
        fontSize: "0.813rem",
        lineHeight: "1rem",
        fontWeight: "500",
        margin: "10px 0 0 0",
        [theme.breakpoints.up("md")]: {
          textAlign: "justify"
        }
      }
    },

  },
}));